export default function getAnalyticDescription(analyticsName: any) {
  switch (analyticsName) {
    case 'Coverage':
      return 'Coverage is the percentage of time the average of the received signal strength indicator (RSSI) from all the clients on the network is better than the average threshold of -72dbm RSSI.'
    case 'AP Health':
      return 'AP Health is the percentage of time the APs have been operational without losing connectivity to the Mist Cloud or rebooting.'
    case 'Capacity':
      return 'Capacity is the percentage of the time the available RF channel capacity is greater than the set threshold.'
    case 'Throughput':
      return 'Throughput is the percentage of time wireless users could achieve the throughput threshold. This SLE is purely theoretical and is fed by data from the Coverage and Capacity SLEs.'
    case 'Successful Connects':
      return 'Percentage of connections that successfully completed during the initial connection, roaming, or ongoing.'
    case 'Time to Connect':
      return 'Time to Connect is the percentage of (successful) connection attempts that were within the specified threshold.'
    case 'Roaming':
      return 'Roaming is the percentage of successful roams exceeding the service level.'

    default:
      return ''
  }
}
